module.exports = __webpack_public_path__ + "media/src/images/zu_12question_snap02-7a96e4957840e4282dac21838fbbc85f.png";